module.exports = __webpack_public_path__ + "img/jingzhuangshu1.7d52d713.jpg";